import React from "react";

export default class StartRecordingButton extends React.Component {
  render() {
    const { onClick, disabled = false, className = "", style } = this.props;
    
    return (
      <button 
        disabled={disabled} 
        className={`lrp-btn lrp-btn-primary ${className}`.trim()} 
        style={style} 
        onClick={onClick}
        title="Start recording"
      >
        Start live read
      </button>
    );
  }
}
